import { render, staticRenderFns } from "./CertifiedTab.vue?vue&type=template&id=4eb7f30b&scoped=true"
import script from "./CertifiedTab.vue?vue&type=script&lang=js"
export * from "./CertifiedTab.vue?vue&type=script&lang=js"
import style0 from "./CertifiedTab.vue?vue&type=style&index=0&id=4eb7f30b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb7f30b",
  null
  
)

export default component.exports